export class StaticPages {
  static termsM = 'terms_m';
  static policyM = 'policy_m';
  static terms = 'terms';
  static policy = 'policy';
  static deleteUser = 'delete_user';
  static deleteAccount = 'delete_account';
  static about = 'about';
  static news = 'news';
  static disclaimer = 'disclaimer';
  static freeReturns = 'freeReturns';
  static appDownload = 'appdownload_m';
  static legacySystem = 'legacy_system';
}
